import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Accordion.css';

const AccordionItem = ({ className = '', children = [], key, ...otherProps }) => {

  const classes = classNames(
    'ng-ui-accordion-item',
    className,
  );

  return (
    <li
      key={key}
      className={classes}
      {...otherProps}
    >
      { children }
    </li>
  );
};

AccordionItem.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.arrayOf(PropTypes.element),
};

AccordionItem.displayName = 'Accordion.AccordionItem';

export default AccordionItem;